module.exports = __webpack_public_path__ + "public/img/sm1.c1009617.svg";